import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { User } from '../../_models/user';
import { Register } from '../../_models/register';
import { Address } from '../../_models/address';
import { Contacts } from '../../_models/contacts';
import * as _ from "lodash";
import { AlertService } from '../../_services/alert.service';


@Component({
  selector: 'app-create-contacts',
  templateUrl: './create-contacts.component.html',
  styleUrls: ['./create-contacts.component.css']
})
export class CreateContactsComponent implements OnInit {

  statusText: string;
  statusText1: string;
  address: Address = {};
  tabClicked = "address";
  addresses: Address[] = [];
  addressTypes: any = [];
  addressType: string;
  deliveryInstructions: string;
  mobile: any;
  customerType: any;
  email: any;
  contactName: string;
  companyName: string;
  geo: string;
  status: string;
  accountOwnerContactId: any;
  selectedWarehouse: any;
  successMessage: any;
  contactsErrorMessage: any
  //statusText1 : string = "";
  statusText2: string = "";
  statusText3: string = "";
  statusText4: string = "";
  statusText5: string = "";
  statusText6: string = "";
  statusText7: string = "";
  statusText8: string = "";
  statusText9: string = "";
  statusText10: string = "";
  statesList: any;
  citiesList: any;

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private api: ApiIntegration, private g: Globals, public user: User, public register: Register) {
    this.g.page = "Create Contact";
    this.address.addressType = "SHIPPING";
    this.stateList();
    this.cityList();
    this.api.getValues("1", "ADDRESS_TYPE", "ADDRESS_TYPE", "ADDRESS_TYPE").subscribe((data: any) => {
      this.addressTypes = data.tripleSetConfigDTOS;
    }, err => {
      this.alertService.error('Error', err);
    });

  }

  nextPage() {
    this.statusText10 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";
    this.statusText9 = "";
    if (this.customerType == '' || this.customerType === null || this.customerType === undefined || this.customerType === 'undefined') {
      this.statusText10 = 'Please select customer type';
    }

    if (this.contactName == '' || this.contactName === null || this.contactName === undefined || this.contactName === 'undefined') {
      this.statusText2 = 'Please enter contact name';
    }
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText3 = 'Please enter email';
    }
    if (this.mobile == '' || this.mobile === null || this.mobile === undefined || this.mobile === 'undefined') {
      this.statusText4 = 'Please enter phone number';
    } else if (this.mobile.length != 10) {
      this.statusText4 = 'phone number minimum 10 characters';
    } else {
      let i = this.mobile.indexOf('0');
      if (i == 0) {
        this.statusText4 = "Number should not start with 0";
      }
    }
    if (this.address.address1 == '' || this.address.address1 === null || this.address.address1 === undefined || this.address.address1 === 'undefined') {
      this.statusText5 = 'Please enter address 1';
    }
    if (this.address.city == '' || this.address.city === null || this.address.city === undefined || this.address.city === 'undefined') {
      this.statusText6 = 'Please enter city';
    }
    if (this.address.state == '' || this.address.state === null || this.address.state === undefined || this.address.state === 'undefined') {
      this.statusText7 = 'Please enter state';
    }
    if (this.address.zip == '' || this.address.zip === null || this.address.zip === undefined || this.address.zip === 'undefined') {
      this.statusText8 = 'Please enter ZIP';
    } else if (this.address.zip.length != 6) {
      this.statusText8 = 'ZIP code must be minimum 6 digits';
    }
    if (this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "" || this.statusText5 != "" || this.statusText6 != "" || this.statusText7 != "" || this.statusText8 != "" || this.statusText10 != "") {
      return false;
    }

    this.tabClicked = "instructions";
  }

  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  changeStateAndCity() {
    this.api.getCityAndStateByPinCode(this.address.zip).subscribe((data: any) => {
      this.address.city = data.city;
      this.address.state = data.state;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit(): void {
  }

  tabChange(tab) {
    this.tabClicked = tab
  }

  selectCustomerType() {
    this.statusText10 = "";
    if (this.customerType == '' || this.customerType === null || this.customerType === undefined || this.customerType === 'undefined') {
      this.statusText10 = 'Please select customer type';
      return false;
    }
  }

  createContactName() {
    this.statusText2 = "";
    if (this.contactName == '' || this.contactName === null || this.contactName === undefined || this.contactName === 'undefined') {
      this.statusText2 = 'Please enter contact name';
      return false;
    }
  }

  createEmail() {
    this.statusText3 = "";
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText3 = 'Please enter email';
      return false;
    }
  }

  createMobile() {
    this.statusText4 = "";
    if (this.mobile == '' || this.mobile === null || this.mobile === undefined || this.mobile === 'undefined') {
      this.statusText4 = 'Please enter phone number';
      return false;
    } else if (this.mobile.length != 10) {
      this.statusText4 = 'phone number minimum 10 characters';
      return false;
    } else {
      let i = this.mobile.indexOf('0');
      if (i == 0) {
        this.statusText4 = "Number should not start with 0";
        return false;
      }
    }
  }

  selectAddressType() {
    this.statusText9 = "";
    if (this.addressType == '' || this.addressType === null || this.addressType === undefined || this.addressType === 'undefined') {
      this.statusText9 = 'Please select addressType';
    }
  }

  createAddress() {
    this.statusText5 = "";
    for (let address of this.addresses) {
      if (!this.address.address1) {
        this.statusText5 = 'Please enter address 1';
        return false;
      }
    }
  }

  createCity() {
    this.statusText6 = "";
    if (this.address.city == '' || this.address.city === null || this.address.city === undefined || this.address.city === 'undefined') {
      this.statusText6 = 'Please enter city';
      return false;
    }
  }

  createState() {
    this.statusText7 = "";
    if (this.address.state == '' || this.address.state === null || this.address.state === undefined || this.address.state === 'undefined') {
      this.statusText7 = 'Please enter state';
      return false;
    }
  }

  createZip() {
    this.statusText8 = "";
    if (this.address.zip == '' || this.address.zip === null || this.address.zip === undefined || this.address.zip === 'undefined') {
      this.statusText8 = 'Please enter ZIP';
      return false;
    } else if (this.address.zip.length != 6) {
      this.statusText8 = 'ZIP code must be minimum 6 digits';
      return false;
    }
  }


  submitContacts() {
    this.g.loaderDisplay = "display";
    this.statusText10 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";
    this.statusText9 = "";
    if (this.customerType == '' || this.customerType === null || this.customerType === undefined || this.customerType === 'undefined') {
      this.statusText10 = 'Please select customer type';
    }

    if (this.contactName == '' || this.contactName === null || this.contactName === undefined || this.contactName === 'undefined') {
      this.statusText2 = 'Please enter contact name';
    }
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText3 = 'Please enter email';
    }
    if (this.mobile == '' || this.mobile === null || this.mobile === undefined || this.mobile === 'undefined') {
      this.statusText4 = 'Please enter phone number';
    } else if (this.mobile.length != 10) {
      this.statusText4 = 'phone number minimum 10 characters';
    } else {
      let i = this.mobile.indexOf('0');
      if (i == 0) {
        this.statusText4 = "Number should not start with 0";
      }
    }
    if (this.address.address1 == '' || this.address.address1 === null || this.address.address1 === undefined || this.address.address1 === 'undefined') {
      this.statusText5 = 'Please enter address 1';
    }
    if (this.address.city == '' || this.address.city === null || this.address.city === undefined || this.address.city === 'undefined') {
      this.statusText6 = 'Please enter city';
    }
    if (this.address.state == '' || this.address.state === null || this.address.state === undefined || this.address.state === 'undefined') {
      this.statusText7 = 'Please enter state';
    }
    if (this.address.zip == '' || this.address.zip === null || this.address.zip === undefined || this.address.zip === 'undefined') {
      this.statusText8 = 'Please enter ZIP';
    } else if (this.address.zip.length != 6) {
      this.statusText8 = 'ZIP code must be minimum 6 digits';
    }
    if (this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "" || this.statusText5 != "" || this.statusText6 != "" || this.statusText7 != "" || this.statusText8 != "" || this.statusText10 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    this.addresses.push(this.address);
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createAccountOwnerContacts', {
      "accountOwnerId": this.user.accountOwnerId,
      "addresses": this.addresses,
      "deliveryInstructions": this.deliveryInstructions,
      "mobile": Number(this.mobile),
      "customerType": this.customerType,
      "companyName": this.companyName,
      "contactName": this.contactName,
      "email": this.email,
      "status": 'ACTIVE',
      "organizationId": 1,
      "source": 'SHIFT'
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Contact', 'Created Successfully');

          this.router.navigate(['/admin/contacts']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
          this.statusText = "Contact creation Failed, please re-try.";
        });
  }

  validateEmail() {
    this.statusText3 = "";
    this.createEmail();

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueEmail?email=' + this.email + "&userType=" + this.customerType ,
      { headers: header1 }).subscribe(data => {
        if (data['code'] == 200) {
        } else {
          if (data['code'] == 400) {
            this.statusText3 = data['message'];
          }
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.statusText3 = "uniqueEmail Failed, please re-try.";
        }
      )
  }

}
